import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';

/**
 * Types
 */
import { SnackbarType } from './SnackbarType';

export interface SnackbarState {
	show: boolean;
	text: string;
	type: SnackbarType;
}

/**
 * Module VueX de gestion des toasts.
 */
@Module({
	namespaced: true
})
export default class Snackbar extends VuexModule {
	/** State */
	show: boolean = false;
	text: string = '';
	type: SnackbarType = SnackbarType.INFO;

	/** Mutations */
	@Mutation
	OPEN({ text, type }: any) {
		this.show = true;
		this.text = text;
		this.type = type;
	}
	@Mutation
	CLOSE() {
		this.show = false;
		this.text = '';
		this.type = 0;
	}

	/** Actions */
	@Action({ commit: 'OPEN' })
	openInfo(text: string) {
		return { text, type: SnackbarType.INFO };
	}
	@Action({ commit: 'OPEN' })
	openError(text: string) {
		return { text, type: SnackbarType.ERROR };
	}
	@Action({ commit: 'CLOSE' })
	close() {
		return;
	}
}